
import React, { Component } from 'react';
import Quotes from "./Quotes"
import Proforma from "./Proforma"
import PaymentRef from "./PaymentRef"
import Basket from "./Basket"
import './App.css';
import {ThreeDots } from "react-loading-icons"
import { BrandHeader, PageHero } from "./BrandChrome";
import { isAppleMobileDevice } from "./appReturn";

const server="https://payments.fhbrundle.co.uk"

let d=Object.fromEntries(new URLSearchParams(window.location.search));

async function digestMessage(message) {
  const encoder = new TextEncoder();
  const data = encoder.encode(message.toUpperCase());
  const hash = await crypto.subtle.digest('SHA-256', data);
  return "VERIFIED_"+new Uint8Array(hash).reduce((a, b) => a + b.toString(16).padStart(2, '0'), '').toUpperCase();
}

export default class App extends Component {
  constructor(props) {
    super(props);
    console.log(d)
    let mode=window.location.pathname
    if(d.ref!=undefined && d.amount!=undefined && d.name!=undefined){
      mode="payment_confirm"
    }

    //We can have another method for having a unique reference that
    this.state = {
          loading:true,
          mode:mode,
          payment_value:d.amount||"",
          payment_ref:d.ref||"",
          payment_name:d.name||"",
          payment_notes:d.note||"",
          reference_lookup:"",
          reference_lookup_loading:false,
          reference_lookup_error:"",
          server_verified:"pending",
          response_data:Object.fromEntries(new URLSearchParams(window.location.search)),
          appurl:"",
          isAppReturn:window.validation === "REDIRECTAPP"
    };
  }

  async componentDidMount(){





if(window.location.pathname=="/success"){
  //its a response back from worldpay
  let data=Object.fromEntries(new URLSearchParams(window.location.search));
  if(data.mac2){
    console.log(data.mac2)
    const verification=await digestMessage(data.mac2)
    console.log(verification)
    if(window.validation==verification){
      this.setState({server_verified:true})
    }
  }


}
if (window.validation === "REDIRECTAPP") {
  let status = encodeURIComponent(window.location.pathname.replace("/", ""));
  // Extract and encode query parameters
  let params = new URLSearchParams(window.location.search.slice(1));
  let encodedParams = Array.from(params.entries()).map(([key, value]) => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');
  const appurl = `fhbapp://payment?status=${status}${
    encodedParams ? `&${encodedParams}` : ""
  }`;

  this.setState({appurl})

  // iOS intermittently leaves an embedded browser blank when a custom URL
  // scheme is opened without a user gesture. Keep the confirmation visible
  // there and let the customer use the Return to app button instead.
  if (!isAppleMobileDevice()) {
    window.location.href = appurl;
  }
}


  }

  

iosClick=(url)=>{
  window.location.href = url;
}

renderResultAction=()=>{
  if(this.state.isAppReturn){
    if(!this.state.appurl) return null

    return(
      <button
        type="button"
        className="payment_link"
        onClick={()=>this.iosClick(this.state.appurl)}
      >
        <div>Return to app</div>
      </button>
    )
  }

  return(
    <button
      type="button"
      className="payment_link"
      onClick={()=>this.setState({mode:"new_payment"})}
    >
      <div>Make another payment</div>
    </button>
  )
}

  request_payment_url=async()=>{
    if(parseFloat(this.state.payment_value)<1 || this.state.payment_value==""){
      alert("Payment value not valid!")
      return
    }
    if(this.state.payment_name.length==0){
      alert("Please provide a payment name")
      return
    }

    if(this.state.payment_ref.length==0){
      alert("Please provide a payment reference")
      return
    }

    this.setState({mode:"payment_frame"})
    this.setState({loading:true})




    let form_data=new FormData()
    form_data.append("payment_name",this.state.payment_name)
    form_data.append("payment_value",this.state.payment_value)
    form_data.append("payment_ref",this.state.payment_ref)
    form_data.append("payment_notes",this.state.payment_notes)
    let response = await fetch(server+'/api?cmd=payment_url', {
        method: 'POST',
        body: form_data
    });
    let data = await response.json();


    if(data.URL){
      window.location=data.URL
      this.setState({mode:""})
      return
      //this.setState({iframe:data.URL})

    }
    else{
      alert("Something went wrong")
      this.setState({mode:""})
    }




    this.setState({loading:false})




  }


  handlechange=(e)=>{
    let v={}
    v[e.target.name]=e.target.value
    this.setState(v)
  }

  open_reference=async(e)=>{
    e.preventDefault()
    const reference=this.state.reference_lookup.trim()

    if(reference.length===0){
      this.setState({reference_lookup_error:"Please enter a reference."})
      return
    }

    const uuidPattern=/^(?:[0-9a-f]{32}|[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12})$/i

    if(uuidPattern.test(reference)){
      window.location.href=`/paylink?ref=${encodeURIComponent(reference)}`
      return
    }

    this.setState({reference_lookup_loading:true,reference_lookup_error:""})

    try{
      const formData=new FormData()
      formData.append("reference",reference)

      const response=await fetch(`${server}/api?cmd=ref_lookup`,{
        method:"POST",
        body:formData
      })

      if(!response.ok){
        throw new Error("Reference lookup failed")
      }

      const data=await response.json()
      const refType=String(data?.ref_type||"").toLowerCase()
      const encodedReference=encodeURIComponent(reference)
      const hasResult=Boolean(data?.ref_type&&data?.ref_data)

      if(hasResult&&refType.startsWith("quote")){
        window.location.href=`/quote?ref=${encodedReference}`
        return
      }

      if(hasResult&&refType.startsWith("proforma")){
        window.location.href=`/proforma?ref=${encodedReference}`
        return
      }

      if(
        (hasResult&&refType.includes("paylink"))||
        (Array.isArray(data?.ref_data)&&data.ref_data.some(item=>item?.pbr_src))
      ){
        window.location.href=`/paylink?ref=${encodedReference}`
        return
      }

      this.setState({
        reference_lookup_loading:false,
        reference_lookup_error:data?.message||"We could not find that reference. Please check it and try again."
      })
    }catch(error){
      this.setState({
        reference_lookup_loading:false,
        reference_lookup_error:"We could not check that reference. Please try again."
      })
    }
  }




  render(){


    if(window.location.pathname.startsWith("/paylink")){
      
      return(<PaymentRef/>)
    }

    if(window.location.pathname.startsWith("/quote")){
      
      return(<Quotes/>)
    }

    if (window.location.pathname.startsWith("/proforma")) {
  return <Proforma />;
}

 if(window.location.pathname.startsWith("/basket")){
      
      return(<Basket/>)
    }
  return (
    <div className="App app-shell">
      <BrandHeader />
      <main className="payment-main">
      <PageHero
        title="Make a secure payment"
        description="Enter your payment details, review the information and continue to our secure payment provider."
        hideIntro={this.state.isAppReturn}
      >
      <div className="payment_container">
        {this.state.mode==""||this.state.mode=="/" ?(
          <div className="payment-entry">
            <div className="payment-entry__option">
              <span className="payment-entry__label">New payment</span>
              <strong>Pay by card</strong>
              <p>Enter your customer code and payment reference manually.</p>
              <button className="payment-entry__button" type="button" onClick={()=>this.setState({mode:"new_payment"})}>Make a payment</button>
            </div>

            <form className="reference-jump" onSubmit={this.open_reference}>
              <label htmlFor="reference-lookup">Existing reference</label>
              <strong>Find a payment</strong>
              <p>Enter a quote, proforma or payment-link reference to continue online.</p>
              <div className="reference-jump__controls">
                <input
                  id="reference-lookup"
                  name="reference_lookup"
                  value={this.state.reference_lookup}
                  className="form_input"
                  type="text"
                  onChange={this.handlechange}
                  placeholder="Quote, proforma or paylink reference"
                  aria-describedby="reference-lookup-message"
                />
                <button type="submit" disabled={this.state.reference_lookup_loading}>
                  {this.state.reference_lookup_loading?"Checking…":"Find reference"}
                </button>
              </div>
              <div
                id="reference-lookup-message"
                className="reference-jump__message"
                role="status"
                aria-live="polite"
              >
                {this.state.reference_lookup_error}
              </div>
            </form>
          </div>
        ):("")}

        {this.state.mode=="new_payment" ? (
          <React.Fragment>
            <div><input name="payment_name" value={this.state.payment_name} className="form_input" type="text"   onChange={this.handlechange}  placeholder="Name/Company"/></div>
            <div><input name="payment_value" value={this.state.payment_value} className="form_input" type="number"   onChange={this.handlechange}  placeholder="Amount in £"/></div>
            <div><input name="payment_ref" value={this.state.payment_ref} className="form_input" type="text" onChange={this.handlechange}  placeholder="Payment reference" /></div>
            <div><textarea name="payment_notes" value={this.state.payment_notes} className="form_input" type="text"  onChange={this.handlechange}  placeholder="Payment notes" /></div>
            <div>
              <button type="button" className="payment_link" onClick={()=>this.setState({mode:"payment_confirm"})}><div>Next</div></button>
              <button type="button" className="payment_link" onClick={()=>this.setState({mode:""})}><div>Back</div></button>
              </div>
          </React.Fragment>
      ):("")}

      {this.state.mode=="payment_confirm" ? (
        <React.Fragment>
          <div className="pad10"><b>{this.state.payment_name}</b> to pay F.H.Brundle <b>£{parseFloat(this.state.payment_value).toFixed(2)}</b></div>
          <div className="pad10">Payment reference:<b>{this.state.payment_ref}</b></div>
          <div className="pad10">Payment notes:<b>{this.state.payment_notes}</b></div>


          <a className="payment_link" onClick={()=>this.request_payment_url()}><div>Proceed</div></a>

          <a className="payment_link" onClick={()=>this.setState({mode:"new_payment"})}><div>Back</div></a>

        </React.Fragment>
    ):("")}


    {this.state.mode=="/success" ?(
        <React.Fragment>
          <div><b>Payment successful {this.state.server_verified==true ? ("✓"):("")}</b></div>
            Amount paid: £{(parseFloat(this.state.response_data.paymentAmount)/100).toFixed(2)}
      <br></br>
            {this.renderResultAction()}
      </React.Fragment>
    ):("")}

    {this.state.mode=="/cancel" ?(
        <React.Fragment>
          <div><b>The payment was cancelled </b></div>

          {this.renderResultAction()}

      </React.Fragment>
    ):("")}

    {this.state.mode=="/failure" ?(
        <React.Fragment>
          <div><b>The payment failed, please try another payment method</b></div>
          {this.renderResultAction()}
      </React.Fragment>
    ):("")}


    {this.state.mode=="/pending" ?(
        <React.Fragment>
          <div><b>The payment is pending {this.state.response_data.status}</b></div>
          {this.renderResultAction()}
      </React.Fragment>
    ):("")}


    {this.state.mode=="/error" ?(
        <React.Fragment>
          <div><b>Something went wrong </b></div>
          {this.renderResultAction()}
      </React.Fragment>
    ):("")}




      </div>
      </PageHero>


{this.state.mode=="payment_frame" ? (
      <div className="payment_container">

        {this.state.loading==true? (<center>
          <div className="progress_snippit">preparing payment page</div>
          <ThreeDots/></center>):(
        <iframe className="payment_frame" src={this.state.iframe} title="F.H.Brundle Payment" />)}
      </div>
):("")}
      </main>
    </div>
  );

}
}
